import { useNavigate } from "react-router-dom";
import HeaderComponent from "../../components/header";
import ContainerComponent from "../../components/conatiner";
import CardComponent from "../../components/card";
import InputComponent from "../../components/input";
import { ChangeEvent, FormEvent, useEffect, useState } from "react";
import { ToastErro, ToastSucesso } from "../../components/toast";
import LoadingComponent from "../../components/loading";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { CreateCostCenters } from "../../services/center_cost";

const CreateCostCenterPage = () => {

    const navigate = useNavigate();

    const [loading, setLoading] = useState<boolean>(false);

    // variaveis para cadastro
    const [description, setDescription] = useState<string>('');
    const [code, setCode] = useState<string>('');
    const [branch, setBranch] = useState<string>('');
    // variaveis para cadastro

    // funcao para cadastrar centro de custo
    const createCostCenters = async (e: FormEvent) => {

        e.preventDefault();

        setLoading(true);

        await CreateCostCenters(description, branch, code).then(resp => {
            ToastSucesso(resp.data.message);
            navigate('/cost_centers');
        }).catch(error => {
            ToastErro(error?.response?.data?.message);
        });

        setLoading(false);

    }
    // funcao para cadastrar centro de custo

    return (
        <>
            <HeaderComponent
                title="Cadastrar Centro de Custo"
                button="Voltar"
                iconButton="arrow_back"
                onClick={() => navigate('/cost_centers')}
            />
            <ContainerComponent>
                {
                    loading

                        ?

                        <LoadingComponent />

                        :

                        <form onSubmit={createCostCenters}>
                            <div className="row">
                                <CardComponent
                                    col={12}
                                >
                                    <>
                                        <div className="card-title mb-4">
                                            Informações do Centro de Custo
                                        </div>
                                        <div className="row">
                                            <InputComponent
                                                label="Descrição do Centro de Custo"
                                                col={6}
                                                defaultValue={description}
                                                onChange={(e: ChangeEvent<HTMLInputElement>) => setDescription(e.target.value)}
                                                required
                                            />
                                            <InputComponent
                                                label="Código"
                                                col={3}
                                                defaultValue={code}
                                                onChange={(e: ChangeEvent<HTMLInputElement>) => setCode(e.target.value)}
                                                required
                                            />
                                            <InputComponent
                                                label="Filial"
                                                col={3}
                                                defaultValue={branch}
                                                onChange={(e: ChangeEvent<HTMLInputElement>) => setBranch(e.target.value)}
                                                required
                                            />
                                        </div>
                                        <div className="d-flex justify-content-end mt-5">
                                            <button className="btn btn-primary" type="submit">Cadastrar</button>
                                        </div>
                                    </>
                                </CardComponent>
                            </div>
                        </form>
                }
            </ContainerComponent>
        </>
    )

}

export default CreateCostCenterPage;